/* Config de moderação editável no backoffice (TASK-PUB-20, ADR-0471). Fonte de verdade do
   SHAPE: `@planuze/config` RemoteConfigSchema (`packRegistry.fastpathEnabled` + `packRegistry.
   scanner`, ADR-0370/0374). Cópia mínima Zod aqui (client-safe, sem Node deps) — o admin-service
   projeta só estas seções do config live e faz read-modify-write no config-service (§4.17). */
import { z } from 'zod';

const scannerSeveritySchema = z.enum(['error', 'warning', 'info']);

export const moderationScannerDto = z.object({
  enabled: z.boolean(),
  maxFindings: z.number().int().positive(),
  maxArchiveBytes: z.number().int().positive(),
  timeoutMs: z.number().int().positive(),
  scanTimeoutMs: z.number().int().positive(),
  dataPayloadMinBase64: z.number().int().positive(),
  maxVendoredFiles: z.number().int().nonnegative(),
  failOn: z.array(scannerSeveritySchema),
  rules: z.array(
    z.object({
      id: z.string().min(1),
      severity: scannerSeveritySchema,
      enabled: z.boolean(),
    }),
  ),
});
export type ModerationScanner = z.infer<typeof moderationScannerDto>;

export const moderationConfigDto = z.object({
  /** Kill-switch global do fastpath de auto-aprovação (ADR-0374). */
  fastpathEnabled: z.boolean(),
  scanner: moderationScannerDto,
});
export type ModerationConfig = z.infer<typeof moderationConfigDto>;

/* Body do PUT: mesmo shape do read (o config-service faz read-modify-write com o config
   inteiro), mas é um contrato distinto (write) — schema próprio, não alias, p/ evoluir só o
   write sem tocar o read e evitar export duplicado (knip). */
export const updateModerationConfigBody = z.object({
  fastpathEnabled: z.boolean(),
  scanner: moderationScannerDto,
});
export type UpdateModerationConfigBody = z.infer<typeof updateModerationConfigBody>;
